const resource = "/medias";

export default ($axios) => ({
	// GET
	getMedia(params={}) {
		params.partnerId = $axios.defaults.headers.common['BW-Admin-Partner-Id'];
		return $axios.get(`${resource}`, { params } );
	},
	getMediaAssignment(assignment, assignmentId, params={}) {
		return $axios.get(`/mediaAssignments/${assignment}/${assignmentId}`, { params } );
	},
	// PUT
	updateMediaAssignment(media, assignment, assignmentId) {
		return $axios.put(`/mediaAssignments/${assignment}/${assignmentId}/${media.id}`, media)
	},
	// POST
	createMediaAssignment(media, assignment, assignmentId) {
		return $axios.post(`/mediaAssignments/${assignment}/${assignmentId}`, media)
	},
	addMedia(files, params={}) {
		const formData = new FormData();
		files.forEach((f) => {
			formData.append('files[]', f)
		});

		Object.keys(params).forEach((key) => {
			formData.append(key, params[key]);
		});

		return $axios.post(`${resource}`, formData)
	},
	// DELETE
	deleteMediaAssignment(media, assignment, assignmentId) {
		return $axios.delete(`/mediaAssignments/${assignment}/${assignmentId}/${media.id}`, media)
	},
});
